import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { Daterangepicker } from 'ng2-daterangepicker';
import { SidebarModule } from 'ng-sidebar';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MaintenanceComponent } from './maintenance.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ModalModule,
        TooltipModule,
        Daterangepicker,
        SidebarModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    declarations: [
        MaintenanceComponent
    ],
})
export class MaintenanceModule { }
